import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { TutorialPages } from '../../../common/src/model.ts';
import { Pages } from '../../../common/src/pages.ts';
import { useUser } from '../data/use_user.tsx';
import { getUrlForPage } from './path.ts';

export function useShowTutorialsButton(): { onTutorialsClick: (() => void) | undefined } {
  const { user } = useUser();
  const navigate = useNavigate();

  const showButton = !user?.tutorialsCompleted?.includes(TutorialPages.FamilyWorship);

  const onTutorialsClick = useCallback(() => {
    void navigate(getUrlForPage(Pages.Tutorials));
  }, [navigate]);

  return { onTutorialsClick: showButton ? onTutorialsClick : undefined };
}
